import {hoistCmp, uses, XH} from '@xh/hoist/core';
import {RzxAppModel} from '../../RzxAppModel';
import {toolbar} from '@xh/hoist/desktop/cmp/toolbar';
import {div, filler} from '@xh/hoist/cmp/layout';
import {appMenuButton, button} from '@xh/hoist/desktop/cmp/button';
import {tooltip} from '@xh/hoist/kit/blueprint';
import {Icon} from '@xh/hoist/icon';
import {whatsNewButton} from '@xh/hoist/desktop/cmp/button/WhatsNewButton';
import './SideNavBar.scss';
import {wsIndicator} from '../wsIndicator/WsIndicator';
import {welcomeMsg} from '../welcomeMsg/WelcomeMsg';
import {aiIcon} from '../ai/AiButton';
import {aiChatButton} from '../aiChat/AiChatPanel';

export const sideNavBar = hoistCmp.factory({
    className: 'side-nav-bar',
    model: uses(RzxAppModel),
    render({model, className}) {
        const {tabs} = model.tabContainerModel,
            appButtons = tabs.map(tab => tabButton({tab, model})),
            sysButtons = [
                aiChatButton({className: 'side-nav-bar__button', icon: aiIcon({size: 'lg'})}),
                whatsNewButton({icon: Icon.gift({size: 'lg', prefix: 'fal'})}),
                appMenuButton({
                    icon: Icon.gear({size: 'lg', prefix: 'fal'}),
                    extraItems: [welcomeMsg()]
                }),
                wsIndicator()
            ];

        return toolbar({
            testId: 'side-nav-bar',
            className,
            vertical: true,
            items: [div({className: 'side-nav-bar__logo', item: XH.clientAppName}), '-', ...appButtons, filler(), ...sysButtons]
        });
    }
});

const tabButton = hoistCmp.factory(({tab}) => {
    return tooltip({
        position: 'right',
        compact: true,
        fill: true,
        popoverClassName: 'side-nav-bar__tooltip',
        item: button({
            testId: `side-nav-${tab.id}-btn`,
            className: 'side-nav-bar__button',
            icon: tab.icon,
            intent: tab.isActive ? 'primary' : null,
            onClick: () => XH.navigate(`default.${tab.id}`)
        }),
        content: tab.tooltip ?? tab.title
    });
});
